// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer___bgKZ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3rdad","obliqueLine":"membershipbadge_obliqueLine__oDW3O"};